import React, { useEffect, createElement } from 'react';
export function ClarityTracker() {
  useEffect(() => {
    // Check if Clarity is already loaded
    if ((window as any).clarity) {
      return;
    }
    try {
      // Create and inject the Clarity script
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.onerror = () => {
        console.warn('Clarity script failed to load (likely blocked by ad blocker or VPN)');
      };
      script.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "ubr2uk6fuf");
      `;
      document.head.appendChild(script);
      return () => {
        // Cleanup if needed
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      };
    } catch (error) {
      console.warn('Failed to initialize Clarity:', error);
    }
  }, []);
  return null;
}